import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/* Navigation that stays in the section it started in.
 *
 * The screens are mounted twice — once under `/` for the authed console
 * and once under `/dev` for the preview harness — so a bare
 * navigate('/estates/sw') from inside the harness lands on the AUTHED route,
 * which bounces the operator to the login page mid-click. Every in-app
 * navigation goes through this. */
export function useConsoleNav(): (to: string) => void {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const prefix = pathname === '/dev' || pathname.startsWith('/dev/') ? '/dev' : '';
  return useCallback(
    (to: string) => {
      navigate(`${prefix}${to === '/' ? '' : to}` || '/');
    },
    [navigate, prefix],
  );
}

/** The prefix on its own, for the places that build a path rather than push one. */
export function useConsolePrefix(): string {
  const { pathname } = useLocation();
  return pathname === '/dev' || pathname.startsWith('/dev/') ? '/dev' : '';
}
